export var DisplayMode;
(function (DisplayMode) {
    DisplayMode["DRAG_ABLE_CARD"] = "DRAG_ABLE_CARD";
    DisplayMode["UPLOAD_BUTTON"] = "UPLOAD_BUTTON";
})(DisplayMode || (DisplayMode = {}));
